import React, { useState, useRef } from 'react';
import styles from '../css/Upload.module.css'; 
import Sidebar from './Sidebar';
import { Navigate } from 'react-router-dom'; 
import { uploadImage, confirmImage, outputApi,removeBgApi } from '../service/apiService';  
import moment from 'moment';  
import { toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

const UploadPage = () => {
  const [imageFile, setImageFile] = useState(null);
  const [processedImageUrl, setProcessedImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageConfirmed, setImageConfirmed] = useState(false);
  const [finalImageDetails, setFinalImageDetails] = useState(null); 
  const fileInputRef = useRef();
  const [fileName, setFileName] = useState('');
  const [activeSection, setActiveSection] = useState('upload');
  const [processedImageFileName, setProcessedImageFileName] = useState('');
  const token = localStorage.getItem('token');
  const [imageHeightMm, setImageHeightMm] = useState(500); 

  const [modalImage, setModalImage] = useState(null);

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
  };
  
  const closeModal = () => {
    setModalImage(null);
  };
  

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setFileName(file ? file.name : ''); 
    setProcessedImageUrl(null);
    setImageConfirmed(false);
  };
  
  // Handle image upload
  const handleUpload = async () => {
    if (!imageFile) return;
    if (imageFile.type !== 'image/png') {
      toast.error('Only PNG files are allowed.');
      return;
    }
    setLoading(true);
    try {
      const data = await uploadImage(imageFile);
      setProcessedImageUrl(`${removeBgApi}${data.processedImagePath}`);
      setProcessedImageFileName(data.processedImagePath); 
    } catch (err) {
      alert('Failed to upload image.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  // Handle image confirmation
  const handleConfirmImage = async () => {
    setImageConfirmed(true);
    try {
      const data = await confirmImage(processedImageFileName,imageHeightMm);
      if (data) {
        setFinalImageDetails({
          message: data.message,
          imageName: data.confirmedImage,
          processedImagePath: `${outputApi}${data.processedImagePath}`,
          processedImageName: data.processedImagePath,
          imageResolution: {
            width: data.imageResolution.width,
            height: data.imageResolution.height
          },
          imageDetails: {
            createdAt: moment(data.imageDetails.createdAt).format('MMMM Do YYYY, h:mm:ss a'),
            displayName: data.imageDetails.displayName,
          },
          pixels: data.pixels,
          mm: data.mm,
          heightMm: imageHeightMm,
        });
      }
    } catch (err) {
      alert('Failed to confirm image.');
      console.error(err);
    }
  };  
  if(!token){
    return <Navigate to="/login" />;
  }
  return (
    <div className={styles.dashboard}>
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} />
      <div className={styles.content}>
        {/* === Step 1: Upload === */}
        {!processedImageUrl && !imageConfirmed && (
          <div className={styles.card}>
            <h3 className={styles.uploadTitle}>Add Image</h3>
            <p className={styles.uploadDescription}>
              Add your image here, and you can upload one at a time.
            </p>
            <div className={styles.uploadArea}>
              <label htmlFor="file-upload" className={styles.uploadAreaLabel}>
                <input
                  type="file"
                  id="file-upload"
                  accept=".jpg,.png"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  className={styles.hiddenFileInput}
                />
                {/* <div className={styles.uploadIcon}></div> */}
                <p className={styles.uploadInstructions}>
                  {fileName ? (
                    <span>Selected File: {fileName}</span>
                  ) : (
                    <>
                      Drag your file(s) to start uploading
                      <br />
                      <span>OR</span>
                      <br />
                      Browse files
                    </>
                  )}
                </p>
              </label>
            </div>
            {imageFile && (
              <div className={styles.inputGroup}>
                <label htmlFor="height-input" className={styles.inputLabel}>
                Enter Guitar Body Height (mm):
                </label>
                <input
                  type="number"
                  id="height-input"
                  min="1"
                  value={imageHeightMm}
                  onChange={(e) => setImageHeightMm(Number(e.target.value))}
                  className={styles.heightInput}
                />
              </div>
            )}
            <p className={styles.supportedFileTypes}>Only support .png images</p>
            <button
              onClick={handleUpload}
              disabled={!imageFile || loading}
              className={styles.uploadButton}
            >
              {loading ? 'Processing...' : 'Upload Image'}
            </button>
          </div>
        )}

        {/* === Step 2: Confirmation === */}
        {processedImageUrl && !imageConfirmed && (
          <div className={styles.card}>
            <h3 className={styles.uploadTitle}>Preview Processed Image</h3>
            <img src={processedImageUrl} alt="Processed result" className={styles.previewImage}onClick={() => openModal(processedImageUrl)}  />
            <div className={styles.modalButtons}>
              <button onClick={handleConfirmImage}>Yes, proceed</button>
              <button
                onClick={() => {
                  setProcessedImageUrl(null);
                  setImageFile(null);
                  setFileName('');
                }}
              >
                Back
              </button>
            </div>
          </div>
        )}

        {/* === Step 3: Final Result === */}
        {imageConfirmed && finalImageDetails && (
          <div className={styles.card}>
            <h3 className={styles.uploadTitle}>Image Processed Result</h3>
            <p><strong>Processed Image:</strong> {finalImageDetails.processedImageName}</p>
            <img
              src={finalImageDetails.processedImagePath}
              alt="Final processed result"
              className={styles.previewImage}
              onClick={() => openModal(finalImageDetails.processedImagePath)}
            />
            <div className={styles.imageDetails}>
              <p><strong>Message:</strong> {finalImageDetails.message}</p>
              <p><strong>Processed Image:</strong> {finalImageDetails.processedImageName}</p>
              <p><strong>Created At:</strong> {finalImageDetails.imageDetails.createdAt}</p>
              <p><strong>Display Name:</strong> {finalImageDetails.imageDetails.displayName}</p>

              <div className={styles.resultInfo}>
                <h4>Resolution:</h4>
                <h5>Width: {finalImageDetails.imageResolution.width}px</h5>
                <h5>Height: {finalImageDetails.imageResolution.height}px</h5>
                <h4>Dimensions in Pixels:</h4>
                <h5>Height: {finalImageDetails.pixels.height}px</h5>
                <h5>Width:</h5>
                <ul>
                  <li><b>Upper Bout:</b> {finalImageDetails.pixels.upperBoutWidth}px</li>
                  <li><b>Middle Bout:</b> {finalImageDetails.pixels.middleBoutWidth}px</li>
                  <li><b>Lower Bout:</b> {finalImageDetails.pixels.lowerBoutWidth}px</li>
                </ul>
                
                <h4>Dimensions in mm:</h4>
                <h5>Height: {finalImageDetails.mm.height} mm</h5>
                <h5>Width:</h5>
                <ul>
                  <li><b>Upper Bout:</b> {finalImageDetails.mm.upperBoutWidth} mm</li>
                  <li><b>Middle Bout:</b> {finalImageDetails.mm.middleBoutWidth} mm</li>
                  <li><b>Lower Bout:</b> {finalImageDetails.mm.lowerBoutWidth} mm</li>
                </ul>
              </div>
            </div>     
            <button
              className={styles.uploadButton}
              onClick={() => {
                setImageFile(null);
                setFileName('');
                setProcessedImageUrl(null);
                setImageConfirmed(false);
                setFinalImageDetails(null);
                setImageHeightMm(500);
              }}
            >
              Back to Upload
            </button>
          </div>
        )}
      {modalImage && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <img src={modalImage} alt="Full View" className={styles.modalImage} />
            <button onClick={closeModal} className={styles.closeButton}>Close</button>
          </div>
        </div>
      )}

      </div>
    </div>
  );
};

export default UploadPage;

